// extracted by mini-css-extract-plugin
export var benefit = "styles-module--benefit--282a9";
export var benefitMobile = "styles-module--benefitMobile--a3742";
export var benefits = "styles-module--benefits--8a187";
export var bubble = "styles-module--bubble--470dc";
export var circle = "styles-module--circle--ab5d1";
export var content = "styles-module--content--91818";
export var description = "styles-module--description--d65dd";
export var descriptionContainer = "styles-module--descriptionContainer--1e165";
export var heading = "styles-module--heading--be6af";
export var icon = "styles-module--icon--126b0";
export var layout = "styles-module--layout--26086";
export var reverse = "styles-module--reverse--f4cba";
export var title = "styles-module--title--b9a3a";